export default {
  meta: {
    title: '商圈报告pdf',
  }
};
